var _a;
import { DcfSdkEnumsObj } from "../../enums/DcfSdkEnum";
export var MerchantRecognitionTokenCookieNames = (_a = {},
    _a[DcfSdkEnumsObj.VISA] = "__Host-payair_srci_mrt_visa",
    _a[DcfSdkEnumsObj.MASTERCARD] = "__Host-payair_srci_mrt_mastercard",
    _a);
